export default [
    {
        name: "LoginLogList",
        path: "logs/logins",
        component: () => import("./views/LoginLogList.vue"),
        meta: {
            title: "Login Log",
            perms: "leads",
            icon: "fa-solid fa-clipboard-list",
        },
    },
];
